(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["events"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".events-filter-btn");
  const events = document.querySelectorAll(".events-list");

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  function filterEvents(type) {
    events.forEach(event => {
      const eventDateText = event.getAttribute("data-date"); 
      const eventDate = new Date(eventDateText);

      if (isNaN(eventDate)) {
        event.style.display = "block";
        return;
      }

      if (type === "all") {
        event.style.display = "block";
      } else if (type === "new") {
        event.style.display = (eventDate >= today) ? "block" : "none";
      } else if (type === "past") {
        event.style.display = (eventDate < today) ? "block" : "none";
      }
    });
  }

  buttons.forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      buttons.forEach(b => b.classList.remove("active"));
      this.classList.add("active");
      const filterType = this.getAttribute("data-filter");
      filterEvents(filterType);
    });
  });

  filterEvents("new");
});

  } catch(e) { console.error(e); }
})();
})();
